module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shipping":{"deliveryDelay":"Legende: ** = delivery delay"}},"fr":{"shipping":{"deliveryDelay":"Légende: ** = délais de Livraison"}}}')
  delete Component.options._Ctor
}
